export const ArrowSend = () => (
  <path
    d='M16.2607 1.05176L7.92628 10.2328M16.2607 1.05176L10.957 17.7446L7.92628 10.2328M16.2607 1.05176L1.10718 6.89424L7.92628 10.2328'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
  />
)
